import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { MatSortModule } from '@angular/material/sort';
import { SharedModule } from '../shared/shared.module';
import { effects } from '../store';
import * as fromPortalRoleReducer from '../store/reducers/portal-roles.reducer';
import * as fromUsersReducer from '../store/reducers/users.reducer';
import { ConfirmDeactivateUserDialogComponent } from './dialogs/confirm-deactivate-user-dialog.component';
import { CreateEditUserDialogComponent } from './dialogs/create-edit-user-dialog.component';
import { ManageUsersComponent } from './manage-users.component';
import { OktaAdminComponent } from './okta-admin/okta-admin.component';

@NgModule({
  imports: [
    SharedModule,
    RouterModule,
    ManageUsersComponent,
    OktaAdminComponent,
    CreateEditUserDialogComponent,
    MatSortModule,
    ConfirmDeactivateUserDialogComponent,
    StoreModule.forFeature('user', fromUsersReducer.reducer),
    StoreModule.forFeature('portalRoles', fromPortalRoleReducer.reducer),
    EffectsModule.forFeature(effects),
  ],
  declarations: [],
  providers: [],
})
export class ManageUsersModule {}
